import type { PayloadAction } from '@reduxjs/toolkit';

import { ServerSide, SET_SERVER_SIDE } from './types';

const initialState: ServerSide = false;

export function serverSideReducer(state = initialState, action: PayloadAction<ServerSide>): ServerSide {
	switch (action.type) {
		case SET_SERVER_SIDE:
			return action.payload;
		default:
			return state;
	}
}
